import { 
	ActionService,
	UploadService 
} from 'phoenix/services';
import { ToastService } from 'sharebase/services/toastService';
import { ShareBaseDocument } from 'phoenix/domain';
import { AppAction } from '../_app/app.actions';

const template = require('./documentReplaceHandler.template');
/**
 * @ngdoc directive
 * @name sharebase-app.directive:sbaDocumentReplaceHandler
 * @module sharebase-app
 * @restrict A
 * @description
 *
 * `sbaDocumentReplaceHandler` displays content of a specific folder/library
 *
 * @usage
 *
 * <sba-document-replace-handler catch-functions="[...]" finally-functions="[...]" /> 
 * 
 * @element input
 * @param {array=} catchFunctions Functions to run when error encountered
 * 
 * @element input
 * @param {array=} finallyFunctions Functions to run at the end of callback
 */
export function DocumentReplaceHandlerDirective():ng.IDirective  {
	return {
		restrict: 'E',
		controller: DocumentReplaceHandlerController,
		controllerAs: 'vm',
		template,
		bindToController: true,
		scope: {
			successCallback: '<',
			errorCallback: '<',
			doneCallback: '<'
		},
		link: (scope, element, attrs, vm:DocumentReplaceHandlerController) => {

			// File input change handler for uploading document revisions
			function documentRevisionHandler(e) {
				vm.uploadDocumentReplacement(e.target);
			}

			vm.replaceDocInput = element.find('input')[0];
			vm.replaceDocInput.addEventListener('change', documentRevisionHandler);

			scope.$on('$destroy', function(){
				vm.replaceUnsub();
				vm.replaceDocInput.removeEventListener('change', documentRevisionHandler);
			});
		}
	};
}

export class DocumentReplaceHandlerController {

	public static $inject = [
			'$q', 
			'$timeout',
			'pxActionService', 
			'pxUploadService', 
			'sbToastService',
			'gettextCatalog'
	];

	constructor(
			private $q:ng.IQService, 
			private $timeout: ng.ITimeoutService,
			private pxActionService:ActionService, 
			private pxUploadService:UploadService, 
			private sbToastService:ToastService,
			private gettextCatalog:ng.gettext.gettextCatalog
	){
		// This data is shared between two async functions
		// that expected to occur in a specific order. The replaceDocument
		// function will be called when the action service emits the REPLACE
		// event. That function saves the target document to this object
		// then clicks the file input handler. uploadDocumentReplacement will
		// be called when the user selects a document. This function needs the
		// document emitted by the REPLACE event in order to properly target
		// the correct document to replace. There may be a safer way to do this,
		// but I found this to be the simplest implementation.

		this.replaceTarget = { document: null, extension: '' };
		this.replaceUnsub = this.pxActionService.subscribe(AppAction.Replace, this.replaceDocument.bind(this));
	}

	public replaceUnsub;
	public replaceTarget;
	public replaceDocInput;

	public successCallback = this.successCallback ? this.successCallback : angular.noop;
	public errorCallback = this.errorCallback ? this.errorCallback : angular.noop;
	public doneCallback = this.doneCallback ? this.doneCallback : angular.noop;

	public replaceDocument(target: ShareBaseDocument): void {
		if (this.replaceDocInput) {
			this.replaceTarget.document = target;
			let fnameArgs = target.Embedded.LatestFile.FileName.split('.');
			this.replaceTarget.extension = '.' + fnameArgs[fnameArgs.length - 1];
			// Lets angular register the new file extenion on the input's accept property
			// before "clicking" the input
			this.$timeout(() => this.replaceDocInput.click(), 0);
		}
	}

	public uploadDocumentReplacement(fileInput:HTMLInputElement) {
		let files = fileInput.files;
		if (files.length === 0) {
			return;
		}

		let tmpDocument = this.replaceTarget.document;
		this.replaceTarget.document = null;
		this.replaceTarget.extension = '';

		this.pxUploadService.replaceFile(files.item(0), tmpDocument.DocumentId, tmpDocument.DocumentName, tmpDocument.Links.Revisions)
			.then(() => this.successCallback())
			.catch((err) => this.errorCallback(err))
			.finally(() => this.doneCallback());
	}

}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/documentReplaceHandler/documentReplaceHandler.ts